import { render } from "./ContextMenuPage.vue?vue&type=template&id=a4a7115e&scoped=true"
import script from "./ContextMenuPage.vue?vue&type=script&lang=js"
export * from "./ContextMenuPage.vue?vue&type=script&lang=js"

import "./ContextMenuPage.vue?vue&type=style&index=0&id=a4a7115e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4a7115e"]])

export default __exports__